import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles<Theme>((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    width: 400,
    height: '100%',
    backgroundColor: theme.palette.common.white,
    overflow: 'hidden',
  },
  header: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    background: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.primary.main}`,
    padding: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    height: 49,
  },
  headerTitle: {
    flex: 1,
    textTransform: 'uppercase',
    fontWeight: '600 !important',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));
